import PromiseBB from "bluebird";
import update from "immutability-helper";
import * as os from "os";
import * as path from "path";
import * as React from "react";
import { Button, Checkbox, Jumbotron, ListGroup, ListGroupItem, Modal, } from "react-bootstrap";
import { ComponentEx, connect, translate } from "../../../controls/ComponentEx";
import FlexLayout from "../../../controls/FlexLayout";
import Spinner from "../../../controls/Spinner";
import { UserCanceled } from "../../../util/CustomErrors";
import { didIgnoreError, isOutdated } from "../../../util/errorHandling";
import * as fs from "../../../util/fs";
import getVortexPath from "../../../util/getVortexPath";
import { showError } from "../../../util/message";
import { loadVortexLogs } from "../util/loadVortexLogs";
class DiagnosticsFilesDialog extends ComponentEx {
    constructor(props) {
        super(props);
        this.state = {
            sessionIdx: -1,
            show: {
                error: true,
                warn: true,
                info: true,
                debug: false,
            },
            logSessions: undefined,
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!this.props.visible && nextProps.visible) {
            this.setState(update(this.state, {
                sessionIdx: { $set: -1 },
                show: {
                    $set: {
                        error: true,
                        warn: true,
                        info: true,
                        debug: false,
                    },
                },
            }));
            this.updateLogs();
        }
    }
    render() {
        const { t, visible } = this.props;
        const { logSessions } = this.state;
        let body;
        if (visible) {
            if (logSessions === undefined) {
                body = (React.createElement(Modal.Body, { id: "diagnostics-files" },
                    React.createElement(Spinner, null)));
            }
            else if (logSessions.length > 0) {
                const sessionsSorted = logSessions.sort((lhs, rhs) => rhs.from.getTime() - lhs.from.getTime());
                body = (React.createElement(Modal.Body, { id: "diagnostics-files" },
                    React.createElement(FlexLayout.Flex, null,
                        React.createElement(ListGroup, { className: "diagnostics-files-sessions-panel" }, sessionsSorted.map(this.renderSession))),
                    React.createElement(FlexLayout.Flex, null, this.renderLog())));
            }
            else {
                body = (React.createElement(Modal.Body, { id: "diagnostics-files" },
                    React.createElement(Jumbotron, { className: "diagnostics-files-error" }, t("An error occurred loading Vortex logs."))));
            }
        }
        return (React.createElement(Modal, { bsSize: "lg", show: visible, onHide: this.props.onHide },
            React.createElement(Modal.Header, null,
                React.createElement(Modal.Title, null, t("View Logs"))),
            body,
            React.createElement(Modal.Footer, null,
                React.createElement(Button, { id: "open-log-folder", onClick: this.openLogFolder }, t("Open Log Folder")),
                React.createElement(Button, { id: "close", onClick: this.props.onHide }, t("Close")))));
    }
    renderSession = (session, index) => {
        const { t, language } = this.props;
        const { sessionIdx } = this.state;
        const errors = session.logs.filter((item) => item.type === "error");
        const from = session.from;
        const to = session.to;
        let isCrashed = "";
        if (session.from === undefined &&
            !session.logs[session.logs.length - 1].text.endsWith("clean application end")) {
            isCrashed = ` - ${t("Crashed")}!`;
        }
        const classes = ["list-group-item"];
        if (sessionIdx === index) {
            classes.push("active");
        }
        const sessionText = (React.createElement("div", { style: { width: "90%" } },
            React.createElement("span", null, t("From") + " "),
            React.createElement("span", { className: "session-from" }, from.toLocaleString(language)),
            React.createElement("span", null, " " + t("to") + " "),
            React.createElement("span", { className: "session-to" }, to.toLocaleString(language)),
            errors.length > 0 ? (React.createElement("span", null, " - " + t("{{ count }} error", { count: errors.length }))) : null,
            React.createElement("span", { className: "session-crashed" }, isCrashed)));
        return (React.createElement(ListGroupItem, { className: classes.join(" "), key: index, value: index, onClick: this.selectSession }, sessionText));
    };
    renderFilterButtons() {
        const { t } = this.props;
        const { logSessions, sessionIdx, show } = this.state;
        const errors = sessionIdx === -1
            ? []
            : logSessions[sessionIdx].logs.filter((item) => item.type === "error");
        return (React.createElement(FlexLayout, { type: "row" },
            ["debug", "info", "warn", "error"].map((type) => (React.createElement("div", { key: type },
                React.createElement(Checkbox, { checked: show[type], className: `log-filter-${type}`, key: `checkbox-${type}`, value: type, onChange: this.toggleFilter }, t(type.toUpperCase()))))),
            React.createElement(FlexLayout.Flex, null),
            React.createElement(Button, { onClick: this.copyToClipboard }, t("Copy to Clipboard")),
            !isOutdated() && !didIgnoreError() && errors.length > 0 ? (React.createElement(Button, { id: `report-log-${sessionIdx}`, onClick: this.reportLog }, t("Report"))) : null));
    }
    renderLogLine(line) {
        return (React.createElement("li", { className: `log-line-${line.type}`, key: line.lineno },
            React.createElement("span", { className: "log-time" }, line.time),
            " - ",
            React.createElement("span", { className: `log-type-${line.type}` }, line.type.toUpperCase()),
            " - ",
            React.createElement("span", { className: "log-text" }, line.text)));
    }
    renderLog() {
        const { logSessions, sessionIdx, show } = this.state;
        if (sessionIdx === -1 || logSessions[sessionIdx] === undefined) {
            return null;
        }
        const enabledLevels = new Set(Object.keys(show).filter((key) => show[key]));
        const filteredLog = logSessions[sessionIdx].logs
            .filter((line) => enabledLevels.has(line.type))
            .map(this.renderLogLine);
        return (React.createElement(FlexLayout, { className: "diagnostics-files-log-panel", type: "column" },
            React.createElement(FlexLayout.Fixed, null, this.renderFilterButtons()),
            React.createElement(FlexLayout.Flex, null,
                React.createElement("ul", { className: "log-list" }, filteredLog))));
    }
    updateLogs() {
        const { onShowError } = this.props;
        return loadVortexLogs()
            .then((sessions) => {
            this.setState(update(this.state, {
                logSessions: { $set: sessions },
            }));
        })
            .catch((err) => {
            onShowError("Failed to read Vortex logs", err);
        });
    }
    toggleFilter = (evt) => {
        const { show } = this.state;
        const filter = evt.currentTarget.value;
        this.setState(update(this.state, { show: { [filter]: { $set: !show[filter] } } }));
    };
    selectSession = (evt) => {
        const idx = evt.currentTarget.value;
        this.setState(update(this.state, { sessionIdx: { $set: idx } }));
    };
    copyToClipboard = () => {
        const { logSessions, sessionIdx, show } = this.state;
        const enabledLevels = new Set(Object.keys(show).filter((key) => show[key]));
        const filteredLog = logSessions[sessionIdx].logs
            .filter((line) => enabledLevels.has(line.type))
            .map((line) => `${line.time} - ${line.type}: ${line.text}`)
            .join(os.EOL);
        window.api.clipboard.writeText(filteredLog);
    };
    openLogFolder = () => {
        const logPath = getVortexPath("userData");
        window.api.shell.openFile(logPath);
    };
    reportLog = (evt) => {
        const { onShowError } = this.props;
        const { logSessions, sessionIdx } = this.state;
        const nativeCrashesPath = path.join(getVortexPath("userData"), "temp");
        const fullLog = logSessions[sessionIdx].logs
            .map((line) => `${line.time} - ${line.type}: ${line.text}`)
            .join(os.EOL);
        this.props.onHide();
        const logPath = path.join(nativeCrashesPath, "session.log");
        fs.ensureDirWritableAsync(nativeCrashesPath, () => PromiseBB.resolve())
            .then(() => fs.writeFileAsync(logPath, fullLog))
            .then(() => {
            this.context.api.events.emit("report-log-error", logPath);
        })
            .catch((err) => {
            if (!(err instanceof UserCanceled)) {
                onShowError("Failed to write log session file", err);
            }
        })
            .then(() => null);
    };
}
function mapStateToProps(state) {
    return {
        language: state.settings.interface.language,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onShowError: (message, details) => showError(dispatch, message, details),
    };
}
export default translate(["common"])(connect(mapStateToProps, mapDispatchToProps)(DiagnosticsFilesDialog));
